import { render, staticRenderFns } from "./ViolationDetailsContainer.vue?vue&type=template&id=7229ce68"
import script from "./ViolationDetailsContainer.vue?vue&type=script&lang=js"
export * from "./ViolationDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports